import { Settings } from '@/components';

const SettingsRoute = () => <Settings />;

export default SettingsRoute;
